/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "create_async_transaction_refund": {
            "nested": {
              "CreateAsyncTransactionRefundError": {
                "values": {
                  "DEFAULT_REFUND_CREATION_STATUS_DO_NOT_USE": 0,
                  "GENERIC_ERROR": 1,
                  "INVALID_REQUEST": 2,
                  "PAYMENT_NOT_FOUND": 3,
                  "INVALID_TRANSACTION_TYPE": 4,
                  "INVALID_REFUND_AMOUNT": 5,
                  "CURRENCY_MISMATCH": 6,
                  "INSUFFICIENT_MERCHANT_BALANCE": 7
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.create_async_transaction_refund?.nested?.CreateAsyncTransactionRefundError) {
  $root.addJSON(jsonData);
}

/**
 * Error types for a failed CreateAsyncTransactionRefundRequest.
 *
 * SOURCE CreateAsyncTransactionRefundError @ squareup/esperanto/common/create_async_transaction_refund.proto at 7:1
 */
export const CreateAsyncTransactionRefundError = $root.lookupEnum('squareup.esperanto.create_async_transaction_refund.CreateAsyncTransactionRefundError').values;